import { toast } from "react-toastify";

const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    cartProducts: sessionStorage.getItem("cartProducts")
    ? JSON.parse(sessionStorage.getItem("cartProducts"))
    : [],
    cartTotalQuantity: sessionStorage.getItem("cartTotalQuantity")
    ? JSON.parse(sessionStorage.getItem("cartTotalQuantity"))
    : 0,
    cartTotalAmount: sessionStorage.getItem("cartTotalAmount")
    ? JSON.parse(sessionStorage.getItem("cartTotalAmount"))
    : 0,
    products: sessionStorage.getItem("products")
    ? JSON.parse(sessionStorage.getItem("products"))
    : [],
}
// const initialState = {
//     cartProducts: [],
//     cartTotalQuantity: 0,
//     cartTotalAmount: 0,
//     products: []
// }

const cartSlice = createSlice({
    name: "cartProduct",
    initialState,
    reducers: {
        addAllProducts: (state, action) => {
            state.products.push(action.payload);
        },
        addToCart: (state, action) => {
            const item = state.cartProducts.find((product) => product._id === action.payload._id);

            if (item) {
                if (item.quantity < Number(item.stock)) {
                    item.quantity += 1;
                    item.total += Number(action.payload.price);
                    toast.info(`Increased product quantity ${item.quantity}`, {
                        position: "bottom-left",
                    });

                    state.cartTotalQuantity += 1;
                    state.cartTotalAmount += Number(action.payload.price);
                }
                else {
                    toast.warning(`This product is not more than ${item.stock} stocks.`, {
                        position: "bottom-left",
                    });
                }

            } else {
                if (action.payload.stock <= 0) {
                    toast.warning("quantity not available", {
                        position: "bottom-left",
                    });
                }
                else {
                    state.cartProducts.push({ ...action.payload, 'quantity': 1, 'total': Number(action.payload.price) });
                    toast.success("Product added to cart", {
                        position: "bottom-left",
                    });

                    state.cartTotalQuantity += 1;
                    state.cartTotalAmount += Number(action.payload.price);
                }
            }

            sessionStorage.setItem("cartProducts", JSON.stringify(state.cartProducts));
            sessionStorage.setItem("cartTotalQuantity", JSON.stringify(state.cartTotalQuantity));
            sessionStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount));
            sessionStorage.setItem("products", JSON.stringify(state.products));
        },
        incrementQNT: (state, action) => {
            const item = state.cartProducts.find((product) => product._id === action.payload._id);

            if (item && item.quantity < Number(item.stock)) {
                item.quantity += 1;
                item.total += Number(action.payload.price);

                state.cartTotalQuantity += 1;
                state.cartTotalAmount += Number(action.payload.price);
            }
            if (!item) {
                state.cartProducts.push({ ...action.payload, 'quantity': 1, 'total': Number(action.payload.price) });
                toast.success("Product added to cart", {
                    position: "bottom-left",
                });

                state.cartTotalQuantity += 1;
                state.cartTotalAmount += Number(action.payload.price);
            }

            sessionStorage.setItem("cartProducts", JSON.stringify(state.cartProducts));
            sessionStorage.setItem("cartTotalQuantity", JSON.stringify(state.cartTotalQuantity));
            sessionStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount));
            sessionStorage.setItem("products", JSON.stringify(state.products));
        },
        detrimentQNT: (state, action) => {
            const item = state.cartProducts.find((product) => product._id === action.payload._id);

            if (item && item.quantity > 1) {
                item.quantity -= 1;
                item.total -= Number(action.payload.price);

                state.cartTotalQuantity -= 1;
                state.cartTotalAmount -= Number(action.payload.price);
            }

            sessionStorage.setItem("cartProducts", JSON.stringify(state.cartProducts));
            sessionStorage.setItem("cartTotalQuantity", JSON.stringify(state.cartTotalQuantity));
            sessionStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount));
            sessionStorage.setItem("products", JSON.stringify(state.products));
        },
        removeItem: (state, action) => {
            const item = state.cartProducts.find((product) => product._id === action.payload._id);

            if (item) {
                item.quantity = 0;
                item.total -= Number(action.payload.quantity) * Number(action.payload.price);
            }
            state.cartTotalQuantity -= Number(action.payload.quantity);
            state.cartTotalAmount -= Number(action.payload.quantity) * Number(action.payload.price);
            state.cartProducts = state.cartProducts.filter((pdItem) => pdItem._id !== action.payload._id);

            toast.success("Product removed to cart", {
                position: "bottom-left",
            });

            sessionStorage.setItem("cartProducts", JSON.stringify(state.cartProducts));
            sessionStorage.setItem("cartTotalQuantity", JSON.stringify(state.cartTotalQuantity));
            sessionStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount));
            sessionStorage.setItem("products", JSON.stringify(state.products));
        },
        setCartEmty: (state, action) => {
            state.cartTotalQuantity = 0;
            state.cartTotalAmount = 0;
            state.cartProducts = [];
            state.products = [];

            sessionStorage.setItem("cartProducts", JSON.stringify(state.cartProducts));
            sessionStorage.setItem("cartTotalQuantity", JSON.stringify(state.cartTotalQuantity));
            sessionStorage.setItem("cartTotalAmount", JSON.stringify(state.cartTotalAmount));
            sessionStorage.setItem("products", JSON.stringify(state.products));
        }
    },
});

export default cartSlice.reducer;
export const { addToCart, incrementQNT, detrimentQNT, removeItem, setCartEmty } = cartSlice.actions;